import script from "./SkillsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsSection.vue?vue&type=script&setup=true&lang=js"

import "./SkillsSection.vue?vue&type=style&index=0&id=077c283e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077c283e"]])

export default __exports__